export const truparkStyles = {
	header: {
		backgroundColor: '#161616',
	},
	sidebar: {
		backgroundColor: '#161616',
		color: 'white',
	},
	button: {
		backgroundColor: '#82c600',
		color: '#fff',
		fontWeight: 600,
		':hover': {
			backgroundColor: '#a3c466',
		},
	},
	title: {
		color: '#fff',
	},
	text: {
		color: '#161616',
		buttonLoadingColor: '#82c600',
	},
	table: {
		headerBackgroundColor: '#008ed8',
		headerTextColor: '#ffffff',
	},
	platformName: {
		name: 'Trupark Platform',
	},
	logo: {
		small: {
			src: '/trupark/trupark-icon.png',
			height: 40,
			width: 45,
		},
		large: {
			src: '/trupark/trupark-logo.png',
			height: 43,
			width: 124,
		},
	},
	favicon: {
		src: '/trupark/trupark-icon.png',
	},
	socials: {
		instagram: 'https://instagram.com/truparkusa',
		facebook: 'https://www.facebook.com/truparkusa',
		linkedIn: 'https://www.linkedin.com/company/trupark-usa/',
	},
	siteUrl: 'https://truparkusa.com/',
	orgName: 'Trupark',
};
